import { render, staticRenderFns } from "./trainingModulePageNew1.vue?vue&type=template&id=5dc9e8ab&scoped=true&"
import script from "./trainingModulePageNew1.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew1.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew1.vue?vue&type=style&index=0&id=5dc9e8ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9e8ab",
  null
  
)

export default component.exports